import React, { useMemo } from 'react';

// Small seeded PRNG so each project always gets the same artwork.
const mulberry32 = (seed) => () => {
  let t = (seed += 0x6d2b79f5);
  t = Math.imul(t ^ (t >>> 15), t | 1);
  t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
  return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
};

const COLS = 8;
const ROWS = 5;
const CELL = 40;

// Generative tile pattern: a nod to pattern recognition.
const ProjectArt = ({ seed, hue, className = '' }) => {
  const tiles = useMemo(() => {
    const rand = mulberry32(seed * 9973);
    const out = [];
    for (let y = 0; y < ROWS; y++) {
      for (let x = 0; x < COLS; x++) {
        out.push({
          x: x * CELL,
          y: y * CELL,
          kind: Math.floor(rand() * 5),
          rot: Math.floor(rand() * 4) * 90,
          tone: Math.floor(rand() * 3),
        });
      }
    }
    return out;
  }, [seed]);

  const tones = [`hsl(${hue} 85% 62%)`, `hsl(${(hue + 40) % 360} 70% 45%)`, `hsl(${hue} 30% 22%)`];

  return (
    <svg
      className={`project-art ${className}`.trim()}
      viewBox={`0 0 ${COLS * CELL} ${ROWS * CELL}`}
      preserveAspectRatio="xMidYMid slice"
      aria-hidden="true"
      focusable="false"
    >
      <rect width="100%" height="100%" fill={`hsl(${hue} 25% 10%)`} />
      {tiles.map((t, i) => {
        const fill = tones[t.tone];
        const transform = `rotate(${t.rot} ${t.x + CELL / 2} ${t.y + CELL / 2})`;
        switch (t.kind) {
          case 0:
            return <circle key={i} cx={t.x + CELL / 2} cy={t.y + CELL / 2} r={CELL / 2.6} fill={fill} />;
          case 1:
            return (
              <path key={i} d={`M${t.x} ${t.y}h${CELL}a${CELL} ${CELL} 0 0 1 -${CELL} ${CELL}z`} fill={fill} transform={transform} />
            );
          case 2:
            return <path key={i} d={`M${t.x} ${t.y}h${CELL}L${t.x} ${t.y + CELL}z`} fill={fill} transform={transform} />;
          case 3:
            return (
              <rect key={i} x={t.x + CELL * 0.2} y={t.y + CELL * 0.2} width={CELL * 0.6} height={CELL * 0.6} rx="4" fill="none" stroke={fill} strokeWidth="3" />
            );
          default:
            return (
              <path key={i} d={`M${t.x} ${t.y + CELL / 2}h${CELL}`} stroke={fill} strokeWidth="3" transform={transform} />
            );
        }
      })}
    </svg>
  );
};

export default ProjectArt;
